import { render, staticRenderFns } from "./HqTenantDetail.vue?vue&type=template&id=c65f78cc"
import script from "./HqTenantDetail.vue?vue&type=script&lang=js"
export * from "./HqTenantDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports